import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-studentsurvey',
  templateUrl: './studentsurvey.component.html',
  styleUrls: ['./studentsurvey.component.scss']
})
export class StudentsurveyComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
